if (!customElements.get('product-form')) {
//   const productForm = document.querySelector('product-form');

// if (productForm) {
//   // Access the variant input (hidden input field that holds the selected variant ID)
//   const variantInput = productForm.querySelector('input[name="id"]');

//   if (variantInput) {
//     // Listen for changes to the variant selection
//     variantInput.addEventListener('change', (event) => {
//       const selectedVariantId = event.target.value;
//       console.log('Selected Variant ID:', selectedVariantId);
// console.log(event.target)
//       // You can now use the selectedVariantId to perform custom logic
//     });
//   }
// }

  // Access the product form element
const productForm = document.querySelector('product-form');

if (productForm) {
  // Access the variant input (hidden input field that holds the selected variant ID)
  const variantInput = productForm.querySelector('input[name="id"]');
  const selectedVariantIdElement = document.getElementById('selected-variant-id');
  const selectedVariantQuantityElement = document.querySelector('#selected-variant-quantity');
  if (variantInput) {
    // Listen for changes to the variant selection
    variantInput.addEventListener('change', (event) => {
      const selectedVariantId = event.target.value;
      // console.log('Selected Variant ID:', selectedVariantId);
      
      // Update the placeholder element with the selected variant ID
      // selectedVariantIdElement.textContent = selectedVariantId;
      //Load variant quantities
      const allVariantQuantities = JSON.parse(document.querySelector('#variant-quantities').textContent);
      // console.log(allVariantQuantities);
      //Replace the content
      // selectedVariantQuantityElement.innerHTML = allVariantQuantities[selectedVariantId];
      //Replace the actual delivery time
      const deliveryTimeText = document.querySelector('#required-delivery-time');
      if (allVariantQuantities[selectedVariantId] > 0) {
        deliveryTimeText.textContent = "🚚 Immediate delivery";
      } else {
        deliveryTimeText.textContent = "🚚 Estimated shipping time 30 Days";
      }
      
    });

    // Initialize the displayed variant ID on page load
     // selectedVariantIdElement.textContent = variantInput.value;
  }
}

  // Function to fetch inventory quantity for a variant
async function fetchVariantInventory(variantId) {
  const query = `
    query GetVariantInventory($id: ID!) {
      productVariant(id: $id) {
        inventoryQuantity
      }
    }
  `;

  const variables = {
    id: `gid://shopify/ProductVariant/${variantId}`
  };

  try {
    const response = await fetch('/api/2023-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'a00527f7464972fcee9d08af7b9e97da' // Replace with your token
      },
      body: JSON.stringify({ query, variables })
    });

    const data = await response.json();
    // return data.data.productVariant.inventoryQuantity;
    console.log("Fetching", data.productVariant)
    return data;
    
  } catch (error) {
    console.log("Error")
    console.error('Error fetching inventory:', error);
    return null;
  }
}

// Example usage in product-form.js
document.addEventListener('DOMContentLoaded', () => {
  const variantSelect = document.querySelector('[name="id"]'); // Variant selector
  const inventoryDisplay = document.querySelector('.inventory-quantity'); // Element to display inventory

  if (variantSelect && inventoryDisplay) {
    variantSelect.addEventListener('change', async (event) => {
      const variantId = event.target.value;
      const inventoryQuantity = await fetchVariantInventory(variantId);

      if (inventoryQuantity !== null) {
        console.log("Quantity ".inventoryQuantity)
        inventoryDisplay.textContent = `Inventory: ${inventoryQuantity}`;
      } else {
        console.log("No Quantity ")
        inventoryDisplay.textContent = 'Inventory not available';
      }
    });
  }
});
  
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        
        return this.form.querySelector('[name=id]');
      }
    }
  );
  
}
